import { format } from 'date-fns';
import { MINUTE_HEIGHT } from '../../../constants/calendar';

interface TimeBlockPreviewProps {
  startMinutes: number;
  endMinutes: number;
  className?: string;
}

const MAX_MINUTES = 24 * 60; // Maximum minutes in a day

export const TimeBlockPreview = ({
  startMinutes,
  endMinutes,
}: TimeBlockPreviewProps) => {
  // Ensure we have valid minute values within a day
  const validStartMinutes = Math.min(Math.max(0, startMinutes), MAX_MINUTES);
  const validEndMinutes = Math.min(
    Math.max(validStartMinutes, endMinutes),
    MAX_MINUTES,
  );
  const duration = Math.max(0, validEndMinutes - validStartMinutes);

  const formatTime = (minutes: number) => {
    if (
      typeof minutes !== 'number' ||
      isNaN(minutes) ||
      minutes < 0 ||
      minutes > MAX_MINUTES
    ) {
      console.warn('Invalid minutes value:', minutes);
      return '00:00';
    }
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const date = new Date(2000, 0, 1, hours, mins);
    return format(date, 'HH:mm');
  };

  return (
    <div
      className={`absolute w-full bg-blue-200 bg-opacity-20 border border-blue-300 pointer-events-none rounded`}
      style={{
        top: `${validStartMinutes * MINUTE_HEIGHT}px`,
        height: `${duration * MINUTE_HEIGHT}px`,
      }}
    >
      <div className="absolute -bottom-5 left-0 right-0 px-2 py-1 text-xs text-blue-600">
        {formatTime(validStartMinutes)} - {formatTime(validEndMinutes)}
      </div>
    </div>
  );
};
